import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE } from ".././apis/baseurldictionary";

const { BaseDomain } = BASE;
const serviceUrl = "Portal/Services";

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({ baseUrl: BaseDomain + serviceUrl }),
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: "",
        method: "POST",
        body: credentials,
      }),
    }),

    getFetchData: builder.mutation({
      query: (credentials) => ({
        url: "",
        method: "POST",
        body: credentials,
        headers: {
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
        },
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
    }),
  }),
});

export const { useLoginMutation, useGetFetchDataMutation } = apiSlice;
